// extracted by mini-css-extract-plugin
export default {"AccordianSummery":"FavouriteGoals_AccordianSummery__SxveG","checkBoxText":"FavouriteGoals_checkBoxText__FImWd","customRadio":"FavouriteGoals_customRadio__F9zeY"};